import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "resource-scroll-area iodine-scrollable-y min-height full-height" }
const _hoisted_2 = {
  key: 0,
  class: "iodine-padding-bottom-md iodine-padding-top-md"
}

import EditsSectionContainer from 'components/resources/edits/EditsSectionContainer.vue';
import { useGrouperStore } from 'stores/grouper-store';
import { EditData } from 'src/contracts/edit';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditsPane',
  setup(__props) {

const sections = [
  {display: 'Medicare Code Edits (MCE)', value: 'MCE'},
  {display: 'TruCode Edits', value: 'TruCode'},
  {display: 'Validation Edits', value: 'Validation'},
  {display: 'RAC', value: 'RAC'},
  {display: 'MNE', value: 'MNE'}
];

const { edits }  = storeToRefs(useGrouperStore());

function getItems(section: string): EditData[] {
  return edits.value?.filter(x => x.type === section);
}

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (section, index) => {
      return _createElementVNode("div", {
        key: section.value,
        class: "io-mfe-ig-edit-section-container"
      }, [
        (index !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_q_separator)
            ]))
          : _createCommentVNode("", true),
        _createVNode(EditsSectionContainer, {
          "section-name": section.display,
          items: getItems(section.value)
        }, null, 8, ["section-name", "items"])
      ])
    }), 64))
  ]))
}
}

})